module.exports = __webpack_public_path__ + "assets/img/learning4.cb91fb88.png";